import { normalizePlaybookKey } from '@/utils';

const PREFIX = 'neogtm_preview_no_exec_eligible';

function normalizedPreviewPlaybookKey(playbookKeyRaw) {
  const raw = String(playbookKeyRaw || '').trim();
  if (raw.toLowerCase().startsWith('event::')) return raw;
  return normalizePlaybookKey(raw);
}

export function previewNoExecEligibleStorageKey(tenantId, playbookKeyRaw, accountId) {
  const pk = normalizedPreviewPlaybookKey(playbookKeyRaw);
  return `${PREFIX}:${tenantId}:${pk}:${String(accountId ?? '')}`;
}

export function setPreviewNoExecutionEligible(tenantId, playbookKeyRaw, accountId) {
  try {
    sessionStorage.setItem(previewNoExecEligibleStorageKey(tenantId, playbookKeyRaw, accountId), '1');
  } catch (_) {
    /* ignore quota / private mode */
  }
}

export function clearPreviewNoExecutionEligible(tenantId, playbookKeyRaw, accountId) {
  try {
    sessionStorage.removeItem(previewNoExecEligibleStorageKey(tenantId, playbookKeyRaw, accountId));
  } catch (_) {
    /* ignore */
  }
}

export function hasPreviewNoExecutionEligible(tenantId, playbookKeyRaw, accountId) {
  try {
    return sessionStorage.getItem(previewNoExecEligibleStorageKey(tenantId, playbookKeyRaw, accountId)) === '1';
  } catch (_) {
    return false;
  }
}
